import React, { PureComponent } from "react";
import ReactDOMServer from "react-dom/server";
import _ from "lodash";
import { Form, Input, Button, notification, Alert } from "antd";
import { withRedux } from "../../hoc";
import { createContactsApi } from "../../services/contacts";
import { sendMail } from "../../services/mail";
import { json2table } from "../../utils";

const FormItem = Form.Item;
const { TextArea } = Input;

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages")
  };
};

const actions = {};

@Form.create()
@withRedux(mapStateToProps, actions)
export default class ContactForm extends PureComponent {
  state = {
    submitting: false,
    errorMessage: null
  };
  submit = async values => {
    const { t } = this.props;
    if (this.state.submitting) return false;
    this.setState({ submitting: true, errorMessage: null });
    const data = {
      ...values
    };
    const createResult = await createContactsApi(data);
    if (_.get(createResult, "status") === "error") {
      this.setState({ errorMessage: _.get(createResult, "message"), submitting: false });
      return false;
    }
    const sendMailResult = await sendMail({
      subject: `${t("คุณมีการติดต่อจาก")} ${_.get(values, "email")}`,
      html: ReactDOMServer.renderToString(
        <div>
          {json2table({
            data: {
              Company: _.get(values, "company"),
              Contact: _.get(values, "name"),
              Address: _.get(values, "address"),
              Telephone: _.get(values, "telephone"),
              "E-mail": _.get(values, "email"),
              "Request, Comment and Suggestions": _.get(values, "message")
            }
          })}
        </div>
      )
    });
    console.log("sendMailResult", sendMailResult);
    notification.success({
      message: t("Send Message Success")
    });
    this.setState({ submitting: false });
    this.props.form.resetFields();
    return true;
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // eslint-disable-next-line no-undef
        gtag_report_conversion();
        this.submit(values);
      }
    });
  };
  render() {
    const { errorMessage, submitting } = this.state;
    const { t } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <React.Fragment>
        {errorMessage && <Alert message={errorMessage} type="warning" showIcon closable />}
        <Form onSubmit={this.handleSubmit} className="contact-form">
          <FormItem colon={false} label={t("Company Name")}>
            {getFieldDecorator("company")(<Input />)}
          </FormItem>
          <FormItem colon={false} label={`${t("Contact Name")}*`}>
            {getFieldDecorator("name", {
              rules: [
                {
                  required: true,
                  message: t("Please input your Name!")
                }
              ]
            })(<Input />)}
          </FormItem>
          <FormItem colon={false} label={t("Address")}>
            {getFieldDecorator("address")(<TextArea rows={4} />)}
          </FormItem>
          <FormItem colon={false} label={`${t("Telephone")}*`}>
            {getFieldDecorator("telephone", {
              rules: [
                {
                  required: true,
                  message: t("Please input your Telephone!")
                }
              ]
            })(<Input />)}
          </FormItem>
          <FormItem colon={false} label={`${t("E-mail")}*`}>
            {getFieldDecorator("email", {
              rules: [
                {
                  type: "email",
                  message: t("The input is not valid E-mail!")
                },
                {
                  required: true,
                  message: t("Please input your E-mail!")
                }
              ]
            })(<Input />)}
          </FormItem>
          <FormItem colon={false} label={t("Request, Comment and Suggestions")}>
            {getFieldDecorator("message")(<TextArea rows={4} />)}
          </FormItem>
          <FormItem colon={false} style={{ textAlign: "right" }}>
            <Button type="danger" htmlType="submit" className="contact-form-button no-shadow" loading={submitting}>
              {t("Send Message")}
            </Button>
          </FormItem>
        </Form>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/ContactForm.js